declare namespace $ {

	type $mol_view__sub_bog_ui_app_badge_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_badge_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_ui_badge__label_bog_ui_app_badge_3 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_badge['label'] >
	>
	type $bog_ui_badge__type_bog_ui_app_badge_4 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_badge['type'] >
	>
	type $bog_ui_badge__label_bog_ui_app_badge_5 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_badge['label'] >
	>
	type $bog_ui_badge__type_bog_ui_app_badge_6 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_badge['type'] >
	>
	type $bog_ui_badge__label_bog_ui_app_badge_7 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_badge['label'] >
	>
	type $bog_ui_badge__type_bog_ui_app_badge_8 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_badge['type'] >
	>
	type $bog_ui_badge__label_bog_ui_app_badge_9 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_badge['label'] >
	>
	type $bog_ui_badge__type_bog_ui_app_badge_10 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_badge['type'] >
	>
	type $bog_ui_badge__label_bog_ui_app_badge_11 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_badge['label'] >
	>
	type $bog_ui_badge__type_bog_ui_app_badge_12 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_badge['type'] >
	>
	type $mol_view__sub_bog_ui_app_badge_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_ui_app_badge extends $mol_page {
		description( ): string
		Description( ): $mol_view
		variants_title( ): string
		Variants_title( ): $mol_view
		Default_badge( ): $bog_ui_badge
		Success_badge( ): $bog_ui_badge
		Warning_badge( ): $bog_ui_badge
		Error_badge( ): $bog_ui_badge
		Info_badge( ): $bog_ui_badge
		Variants( ): $mol_view
		title( ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=badge.view.tree.d.ts.map